<template>
  <div class="elevatorList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input class="searchInput" v-model="macName" placeholder="请输入设备序列号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="state">
            <el-option label="请选择设备状态" value=""></el-option>
            <el-option label="在线" value="0"></el-option>
            <el-option label="调试" value="1"></el-option>
            <el-option label="下线" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="devName">
            <el-option label="请选择设备类别" value=""></el-option>
            <el-option label="曳引与强制驱动电梯" value="曳引与强制驱动电梯"></el-option>
            <el-option label="自动扶梯" value="自动扶梯"></el-option>
            <el-option label="曳引驱动乘客电梯" value="曳引驱动乘客电梯"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="commit()">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="equipmentType" label="设备类型" width="180">
        </el-table-column>
        <el-table-column prop="GardenName" label="设备名称">
          <template slot-scope="scope">
            {{scope.row.GardenName}} {{scope.row.Name}}
          </template>
        </el-table-column>
        <el-table-column prop="MacName" label="设备序列号" width="230">
        </el-table-column>
        <el-table-column prop="State" label="设备状态">
          <template slot-scope="scope">
            <span v-if="scope.row.State == 0" style="color:#67C23A;">在线</span>
            <span v-if="scope.row.State == 1">调试</span>
            <span v-if="scope.row.State == 2" style="color:red;">离线</span>
          </template>
        </el-table-column>
        <el-table-column prop="DevName" label="设备类别">
        </el-table-column>
        <el-table-column prop="Devmodel" label="硬件型号">
        </el-table-column>
        <el-table-column prop="YsNumber" label="国标id" width="230">
        </el-table-column>
        <el-table-column prop="liftOfflineTime" label="最后离线时间">
          <template slot-scope="scope">
            {{ scope.row.liftOfflineTime | time }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <!-- <el-button @click="detail(scope.row)">查看</el-button> -->
            <el-button @click="edit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 修改弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" style="padding:0 30px;" @closed="handleDialogClosed">
      <el-form :model="ruleForm" name="frm" ref="ruleForm" class="wid100" :label-width="require('@/config/enum').c_ws3"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- <el-form-item tem label="设备名称" prop="GardenName">
          <el-input type="text" v-model="ruleForm.GardenName" class="item-input"></el-input>
        </el-form-item> -->
        <el-form-item tem label="设备序列号" prop="MacName">
          <el-input type="text" v-model="ruleForm.MacName" class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="在线状态" prop="State">
          <!-- <el-input type="text" v-model="ruleForm.MacName" class="item-input"></el-input> -->
          <el-select v-model="ruleForm.State">
            <el-option label="在线" value=0></el-option>
            <el-option label="调试" value=1></el-option>
            <el-option label="下线" value=2></el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="设备类别" prop="DevName">
          <!-- <el-input type="text" v-model="ruleForm.DevName" class="item-input"></el-input> -->
          <el-select v-model="ruleForm.DevName">
            <el-option label="曳引与强制驱动电梯" value="曳引与强制驱动电梯"></el-option>
            <el-option label="自动扶梯" value="自动扶梯"></el-option>
            <el-option label="曳引驱动乘客电梯" value="曳引驱动乘客电梯"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="硬件型号" prop="Devmodel">
          <el-input type="text" v-model="ruleForm.Devmodel" class="item-input"></el-input>
        </el-form-item>
        <el-form-item tem label="国标id" prop="YsNumber">
          <el-input type="text" v-model="ruleForm.YsNumber" class="item-input"></el-input>
        </el-form-item>

      </el-form>
      <div style="text-align:center;">
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:elevatorList
   *@Description:电梯物联网设备列表
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.elevatorList',
    data() {
      return {
        tableData: [], // table列表数据
        macName: '', // 设备序列表号
        state: '', // 在线状态
        devName: '', // 设备类别
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        ruleForm: '', // 查看详情数据
        diaIsShow: false, // 弹框是否显示
        titleShow: '修改设备信息', // 弹框标题
        threeId: '',
        threeType: '3',
      }
    },
    watch: {},
    created() {
      this.getData()
    },
    methods: {
      // 获取列表数据
      getData() {
        let loading = this.$loading()
        this.$get(
          `aapi/liftMonitor?threeId=${this.threeId}&threeType=${this.threeType}&macName=${this.macName}&state=${this.state}&devName=${this.devName}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 修改弹窗
      edit(rowData) {
        this.ruleForm = this.deepClone(rowData)
        this.ruleForm.State = this.ruleForm.State + ''
        console.log(this.ruleForm)
        this.diaIsShow = true
      },

      // 修改保存
      save() {
        console.log(this.ruleForm)
        let loading = this.$loading()
        this.$postJson(`aapi/modifyLift`, {
          'macName': this.ruleForm.MacName,
          'state': this.ruleForm.State,
          'devName': this.ruleForm.DevName,
          'devmodel': this.ruleForm.Devmodel,
          'ysNumber': this.ruleForm.YsNumber,
          'id': this.ruleForm.Id,
        }).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$message.success('修改成功')
              this.diaIsShow = false
              this.commit()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },

      // 监听关闭dialog
      handleDialogClosed() {

      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 深度克隆
      deepClone(obj) {
        var _obj = JSON.stringify(obj)
        var objClone = JSON.parse(_obj)
        return objClone
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .elevatorList {
    .el-dialog__body {
      padding: 20px !important;
    }

    .el-input.is-disabled .el-input__inner {
      color: #606266;
    }
  }
</style>